import React, { useState, useEffect, useRef } from 'react';

import { Mail } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { 
  Character
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";

import CharacterMailInput from "@dndComponents/character/receivables/CharacterMailInput";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  char: Character;
  recalc_time: number;
  disabled: boolean;
}

const common_util = CommonUtilities.getInstance();

export default function CharacterMailButton({
  char,
  recalc_time,
  disabled,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [flashing, setFlashing] = useState((
    char.receivables.filter(o => o.received_dt === 0).length > 0
  ));
  const [open, setOpen] = useState(false);
  const [prev_recalc_time, setRecalcTime] = useState(recalc_time);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      char.subscription_holder.subscribe("Receivables", mounted, receivablesChanged);
      // console.log(id);
      setFetched(true);
    }
  });

  const receivablesChanged = () => {
    setRecalcTime(common_util.get_time_number());
  }

  const recalc = () => {
    if (char.receivables.filter(o => o.received_dt === 0).length > 0) {
      if (!flashing) {
        setFlashing(true);
      }
    } else if (flashing) {
      setFlashing(false);
    }
  }
  
  useEffect(() => {
    if (recalc_time !== prev_recalc_time) {
      setRecalcTime(recalc_time);
      recalc();
    }
    // eslint-disable-next-line
  }, [recalc_time, prev_recalc_time]);

  const renderExtras = () => {
    return (
      <ModalOrDrawer 
        open={ open } 
        full_page
        onClose={() => {
          setOpen(false); 
          char.subscription_holder.modalClosed();
        }}>
        { open &&
          <Grid container spacing={0} direction="row" 
            style={{ maxHeight: window.innerHeight - 34 }}>
            <Grid
              size={{
                xs: 12
              }}>
              <CharacterMailInput
                char={char}
                onChange={(changed: Character, do_main: boolean) => {
                  // debugger;
                  char.changed();
                  char.subscription_holder.recalculate();
                }}
              />
            </Grid>
          </Grid>
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <Tooltip title="Mail">
        <Mail
          className={ flashing ? "Flashing clickable" : "clickable" }
          onClick={() => {
            if (!disabled) {
              setOpen(true);
            }
          }}
        />
      </Tooltip>
      { renderExtras() }
    </>
  ); 
}
